export default __webpack_public_path__ + "static/voting-e4497d22ea71bf5d2dbc243a83b46f6c.webp";